export default function buildUrlFromOptions(input: {
    sort: string
    page: number
    selectedCategories: any
    selectedSpecifications: any
    selectedBedrooms: any
    selectedLocations: any
    selectedBrands: any
    selectedTypes: any
    minprice: number | null
    maxprice: number | null
    mindimension: number | null
    maxdimension: number | null
    currentLanguageId: number
    currentPageId?:number
}) {
    let filterString = ''
    if (input.sort != '' && input.sort != 'default') {
        filterString += `&sort=${input.sort}`
    }
    if (input.page > 1) {
        filterString += `&page=${input.page}`
    }
    if (input.selectedCategories.length > 0) {
        filterString += '&categories=' + input.selectedCategories.join(',')
    }
    if (input.selectedSpecifications.length > 0) {
        filterString += '&specs=' + input.selectedSpecifications.join(',')
    }
    if (input.selectedBedrooms.length > 0) {
        filterString += '&bedrooms=' + input.selectedBedrooms.join(',')
    }
    if (input.selectedLocations.length > 0) {
        filterString += '&locations=' + input.selectedLocations.join(',')
    }
    if (input.selectedBrands.length > 0) {
        filterString += '&brands=' + input.selectedBrands.join(',')
    }
    if (input.selectedTypes.length > 0) {
        filterString += '&types=' + input.selectedTypes.join(',')
    }
    if (input.minprice! > 0) {
        filterString += '&minprice=' + input.minprice
    }
    if (input.maxprice! > 0) {
        filterString += '&maxprice=' + input.maxprice
    }
    if (input.mindimension! > 0) {
        filterString += '&mindimension=' + input.mindimension
    }
    if (input.maxdimension! > 0) {
        filterString += '&maxdimension=' + input.maxdimension
    }
    if (input.currentLanguageId) {
        filterString += '&lang=' + input.currentLanguageId
    }
    if (input.currentPageId) {
        filterString += '&pageId=' + input.currentPageId
    }
    if (filterString != '') {
        filterString = filterString.substr(1)
    }
    return filterString
}



// WEBPACK FOOTER //
// ./react/src/utils/buildUrlFromOptions.ts